/**
 * Trần độ dài ghi chú khi khai "tôi đã chuyển" — MỘT nguồn cho contract HTTP (`payReportNoteSchema`
 * ở `@goppy/contracts` collections + member-dues-batch). Tách ra từ `pay-report-form.ts` (v1, đã xoá,
 * US-AIV2-0002) vì contracts KHÔNG-AI đang import; trang `PAY-REPORT` v2 (0036) đọc lại hằng này.
 */
export const PAY_REPORT_NOTE_MAX_LENGTH = 200;
